// Generated by portal/sdk/scripts/build.js.
module.exports = "/app-prompt/milla-app-prompt.f3af389881e4.js";
